
import styled from "styled-components";
import { theme } from "../../../../../../helpers/theme";
import { PricelistOffersGetByIdSubcontractorOffers } from "../../../../../../services/orders/pricelist-offers-get-by-id/types";
import FormFieldInfo from "../../../../../common-views/offer-form/components/form-field-info/form-field-info";
import { WorningIcon } from "../../view-variants/helpers/worning-icon";

interface OfferSummaryProps {
    oferty_podwykonawcy: PricelistOffersGetByIdSubcontractorOffers[],
    oferta_id: string,
};
interface OfferPriceResults {
    sum: number;
    isWorrning: boolean;
    oferta_id: string;
};
export const offerPrice = (
    value: PricelistOffersGetByIdSubcontractorOffers[],
    oferta_id: string
)
    : OfferPriceResults => {
    let _sum: number = 0;
    let _isWorrning: boolean = false;
    value.map((item) => {
        item.pozycje_oferty.map((_item) => {
            _sum += _item.cena_docelowa===null?0:_item.cena_docelowa;
            //_sum += _item.cena_docelowa;
            _isWorrning = _item.wymaga_wyceny ? true : _isWorrning;
        })
    }
    );
    let result: OfferPriceResults = {
        sum: _sum,
        isWorrning: _isWorrning,
        oferta_id: oferta_id,
    }

    return result;
};


export const OfferSummary = ({
    oferty_podwykonawcy,
    oferta_id,
}: OfferSummaryProps) => {

    return (
        <>
            {/* <Divider sx={{ marginTop: '16px', marginBottom: '16px' }} /> */}
            <Container>
                <Title>Suma</Title>
                <InfoWrapper>
                    <FormFieldInfo
                        noPadding={true}
                        popoverLabel={""}
                        popoverContent={"Lorem Ipsum 3"}
                    />
                </InfoWrapper>
                <TotalValue>
                    <Wrapper>
                       {Number(offerPrice(oferty_podwykonawcy, oferta_id).sum)!==0 
                       ?
                       <>
                       {Number(offerPrice(oferty_podwykonawcy, oferta_id).sum).toFixed(2)} zł
                        <IconWrapper
                            isWorrning={offerPrice(oferty_podwykonawcy, oferta_id).isWorrning}
                        >
                            <WorningIcon />
                        </IconWrapper>
                       </>
                        :null}
                    </Wrapper>
                </TotalValue>
            </Container >
        </>
    );
};



const Container = styled.div`
margin-top:23px;
position:relative;
background: ${theme.colors.gray05_input};
border-radius: ${theme.radius.thirdRadius};
border:1px solid ${theme.colors.gray03_border2};
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: end;
padding: 14px 16px;
`;
const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.blue01_active};
`;
const TotalValue = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.blue01_active};
`;
const Wrapper = styled.div`
display:flex;
flex-direction:row;
`;
const IconWrapper = styled.div<{
    isWorrning: boolean;
}>`
display: ${(props: any) => (props.isWorrning ? "flex" : "none")};
`;


const InfoWrapper = styled.div`
position:absolute;
top:14px;
left:55px;
display:flex;
width:20px;
height:20px;
width:20px;
& div{
    width:20px;
    height:20px;
}

`;